(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["monarch-fabric-care"] && !Shopify.designMode) return;
  try {
    (() => {
    const decorPattern = /[✨📌🧵✔]/g;
    const materialPattern =
      /\b(TR|cotton|linen|viscose|polyester|crepe|denim|wool|chiffon|tweed|knit|satin|georgette|blend|fabric)\b|قطن|قطني|كتان|فيسكوز|بوليستر|كريب|دينم|جينز|صوف|شيفون|تويد|تريكو|ساتان|جورجيت|خامة|نسيج/i;
    const skipPattern = /carefully inspected|shipping|exchange|delivery|size|measurement|length|color|colour|fit:|الشحن|الاستبدال|التوصيل|المقاس|المقاسات|القياس|الطول|اللون|القَصّة|القصة/i;
    const fabricHeadingPattern = /^(?:fabric|material)\b|^(?:الخامة|الخامات)\s*/i;
    const fabricLabelPattern = /^(?:fabric|material|الخامة|الخامات)\s*[:：-]\s*(.+)$/i;

    const cleanText = (value) =>
      (value || '')
        .replace(decorPattern, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^[|:.\-\s]+|[|:.\-\s]+$/g, '');

    const textFromTemplate = (template) => {
      const source = document.createElement('div');
      source.append(template.content.cloneNode(true));
      source.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
      source.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, div').forEach((node) => node.append('\n'));
      return source.textContent || '';
    };

    const toLines = (text) =>
      text
        .split(/\n|•|✔/)
        .map(cleanText)
        .filter(Boolean);

    const afterLabel = (line, labelPattern) => {
      const match = line.match(labelPattern);
      return match ? cleanText(match[1]) : '';
    };

    const pickNextUsefulLine = (lines, startIndex) => {
      for (let index = startIndex + 1; index < lines.length; index += 1) {
        const line = cleanText(lines[index]);
        const directFabric = afterLabel(line, fabricLabelPattern);
        if (directFabric && !skipPattern.test(directFabric)) return directFabric;
        if (!line || fabricHeadingPattern.test(line) || /details|construction|التفاصيل|التكوين/i.test(line)) continue;
        if (skipPattern.test(line)) continue;
        if (line.length >= 3) return line;
      }
      return '';
    };

    const pickFabric = (lines) => {
      for (let index = 0; index < lines.length; index += 1) {
        const line = lines[index];
        const directFabric = afterLabel(line, fabricLabelPattern);
        if (directFabric && !skipPattern.test(directFabric)) return directFabric;

        if (fabricHeadingPattern.test(line)) {
          const nextLine = pickNextUsefulLine(lines, index);
          if (nextLine) return nextLine;
        }
      }

      const materialLine = lines.find((line) => materialPattern.test(line) && !skipPattern.test(line));
      if (!materialLine) return '';

      const sentence = materialLine.split(/[.!?]/).find((part) => materialPattern.test(part)) || materialLine;
      return cleanText(sentence).replace(/^crafted from\s+/i, '').replace(/^made from\s+/i, '');
    };

    const pickCare = (lines) => {
      const explicitCare = lines.find(
        (line) => /wash|dry clean|machine wash|hand wash|iron|bleach|tumble dry|غسل|تنظيف جاف|غسالة|يدوي|مكواة|كيّ|مبيض|مجفف/i.test(line) && !/shipping|exchange|الشحن|الاستبدال/i.test(line)
      );
      return explicitCare ? cleanText(explicitCare) : '';
    };

    const renderFabricCare = (root = document) => {
      root.querySelectorAll('[data-monarch-fabric-care]').forEach((block) => {
        if (block.dataset.ready === 'true') return;
        const template = block.querySelector('[data-monarch-fabric-care-source]');
        const output = block.querySelector('[data-monarch-fabric-care-output]');
        if (!template || !output) return;

        const lines = toLines(textFromTemplate(template));
        const fabric = pickFabric(lines);
        const care = pickCare(lines) || block.dataset.defaultCare || '';
        output.replaceChildren();

        if (!fabric) {
          const empty = document.createElement('p');
          empty.className = 'monarch-fabric-care__value';
          empty.textContent = block.dataset.emptyMessage || care;
          output.append(empty);
          block.dataset.ready = 'true';
          return;
        }

        [
          [block.dataset.fabricLabel || 'Fabric', fabric],
          [block.dataset.careLabel || 'Care', care],
        ].forEach(([label, value]) => {
          const item = document.createElement('div');
          const labelElement = document.createElement('span');
          const valueElement = document.createElement('p');
          item.className = 'monarch-fabric-care__item';
          labelElement.className = 'monarch-fabric-care__label';
          valueElement.className = 'monarch-fabric-care__value';
          labelElement.textContent = label;
          valueElement.textContent = value;
          item.append(labelElement, valueElement);
          output.append(item);
        });

        block.dataset.ready = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => renderFabricCare());
    } else {
      renderFabricCare();
    }

    document.addEventListener('shopify:section:load', (event) => renderFabricCare(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["monarch-product-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanText = (text) => text.replace(/\s+/g, ' ').trim();
    const cleanLine = (text) => cleanText(text)
      .replace(/^[\s|:.,\-–—•✔✨📌🧵]+/u, '')
      .replace(/\s+/g, ' ')
      .trim();

    const extractLines = (text) => {
      const seen = new Set();
      return text
        .split(/\n|✔|•/)
        .map(cleanLine)
        .filter((line) => line && /[\p{L}\p{N}]/u.test(line))
        .filter((line) => {
          const key = line.toLocaleLowerCase();
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
    };

    const textFromNode = (node) => {
      const clone = node.cloneNode(true);
      clone.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
      return clone.textContent || '';
    };

    const sectionLabel = (heading) => cleanLine(textFromNode(heading));

    const isHeading = (node) => /^H[1-4]$/.test(node.tagName);

    const isSizeSection = (label) => /size|chart|measurement|مقاس|مقاسات|قياس|قياسات|جدول/i.test(label);

    const valuesFromNode = (node) => {
      if (node.tagName === 'TABLE' || node.querySelector('table')) return [];
      const listItems = Array.from(node.querySelectorAll('li'));
      if (listItems.length) {
        return listItems.flatMap((item) => extractLines(textFromNode(item)));
      }
      return extractLines(textFromNode(node));
    };

    const collectIntro = (source) => {
      const intro = [];
      for (const child of Array.from(source.children)) {
        if (isHeading(child) || child.tagName === 'TABLE' || child.querySelector('table')) break;
        const line = valuesFromNode(child).join(' ');
        if (line.length >= 18 && intro.length < 3) intro.push(line);
        if (intro.length >= 3) break;
      }
      return intro;
    };

    const collectSections = (source) => {
      const sections = [];
      const children = Array.from(source.children);
      children.forEach((child, index) => {
        if (!isHeading(child)) return;

        const label = sectionLabel(child);
        if (!label || isSizeSection(label)) return;

        const values = [];
        for (let cursor = index + 1; cursor < children.length; cursor += 1) {
          const node = children[cursor];
          if (isHeading(node)) break;
          valuesFromNode(node).forEach((line) => {
            if (line && !values.includes(line)) values.push(line);
          });
        }

        if (values.length) {
          sections.push({ label, values });
        }
      });
      return sections;
    };

    const renderDetails = (root = document) => {
      root.querySelectorAll('[data-monarch-product-details]').forEach((block) => {
        if (block.dataset.ready === 'true') return;
        const template = block.querySelector('[data-monarch-product-details-source]');
        const output = block.querySelector('[data-monarch-product-details-output]');
        if (!template || !output) return;

        const source = document.createElement('div');
        source.append(template.content.cloneNode(true));
        const intro = collectIntro(source);
        const sections = collectSections(source);

        output.replaceChildren();

        if (intro.length) {
          const introElement = document.createElement('div');
          introElement.className = 'monarch-product-details__intro';
          intro.forEach((line) => {
            const paragraph = document.createElement('p');
            paragraph.textContent = line;
            introElement.append(paragraph);
          });
          output.append(introElement);
        }

        if (sections.length) {
          const sectionList = document.createElement('div');
          sectionList.className = 'monarch-product-details__sections';
          sections.forEach(({ label, values }) => {
            const section = document.createElement('article');
            const heading = document.createElement('h3');
            section.className = 'monarch-product-details__section';
            heading.textContent = label;
            section.append(heading);

            if (values.length > 1) {
              const list = document.createElement('ul');
              values.forEach((value) => {
                const item = document.createElement('li');
                item.textContent = value;
                list.append(item);
              });
              section.append(list);
            } else {
              const paragraph = document.createElement('p');
              paragraph.textContent = values[0];
              section.append(paragraph);
            }

            sectionList.append(section);
          });
          output.append(sectionList);
        }

        if (!intro.length && !sections.length) {
          const empty = document.createElement('p');
          empty.className = 'monarch-product-details__empty';
          empty.textContent = block.dataset.emptyMessage || '';
          output.append(empty);
        }

        block.dataset.ready = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => renderDetails());
    } else {
      renderDetails();
    }

    document.addEventListener('shopify:section:load', (event) => renderDetails(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["monarch-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanText = (text) => text.replace(/\s+/g, ' ').trim();
    const normalizeLabel = (text) => cleanText(text)
      .replace(/size chart/gi, '')
      .replace(/\|.*$/g, '')
      .replace(/^[^A-Za-z0-9]+/g, '')
      .trim();

    const inferProductLabel = (title) => {
      const types = ['dress', 'skirt', 'shirt', 'blouse', 'pants', 'pant', 'coat', 'jacket', 'vest', 'top'];
      const lowerTitle = title.toLowerCase();
      const match = types.find((type) => lowerTitle.includes(type));
      if (!match) return '';
      return match === 'pant' ? 'Pants' : match.charAt(0).toUpperCase() + match.slice(1);
    };

    const cleanTable = (table) => {
      const clone = table.cloneNode(true);
      clone.querySelectorAll('*').forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name !== 'colspan' && attribute.name !== 'rowspan') {
            element.removeAttribute(attribute.name);
          }
        });
      });
      clone.querySelectorAll('th').forEach((header) => {
        header.scope = 'col';
        header.textContent = cleanText(header.textContent).replace(/\s*\(cm\)\s*/gi, '');
      });
      clone.querySelectorAll('td').forEach((cell) => {
        cell.textContent = cleanText(cell.textContent);
      });
      return clone;
    };

    const getTableHeaders = (table) => Array.from(table.querySelectorAll('thead th')).map((header) => cleanText(header.textContent));

    const getTableRows = (table) => Array.from(table.querySelectorAll('tbody tr'))
      .map((row) => Array.from(row.children).map((cell) => cleanText(cell.textContent)))
      .filter((row) => row.some(Boolean));

    const shouldUseWideTable = (headers) => headers.length > 5 || headers.some((header) => header.length > 14);

    const buildSizeCards = (table) => {
      const headers = getTableHeaders(table);
      const rows = getTableRows(table);
      if (!headers.length || !rows.length) return null;

      const cards = document.createElement('div');
      cards.className = 'monarch-size-guide-drawer__cards';

      rows.forEach((row) => {
        const card = document.createElement('article');
        const title = document.createElement('div');
        card.className = 'monarch-size-guide-drawer__card';
        title.className = 'monarch-size-guide-drawer__card-title';
        title.textContent = row[0] ? `${headers[0]} ${row[0]}` : headers[0];
        card.append(title);

        headers.slice(1).forEach((header, index) => {
          const value = row[index + 1];
          if (!value) return;
          const item = document.createElement('div');
          const label = document.createElement('span');
          const measurement = document.createElement('span');
          item.className = 'monarch-size-guide-drawer__card-row';
          label.textContent = header;
          measurement.textContent = value;
          item.append(label, measurement);
          card.append(item);
        });

        cards.append(card);
      });

      return cards;
    };

    const enhanceResponsiveTables = (root = document) => {
      root.querySelectorAll('.monarch-size-guide-drawer__panel--product .monarch-size-guide-drawer__table-wrap').forEach((wrap) => {
        const table = wrap.querySelector('table');
        if (!table || table.dataset.monarchResponsiveTable === 'true') return;

        const headers = getTableHeaders(table);
        if (shouldUseWideTable(headers)) {
          table.classList.add('monarch-size-guide-drawer__table--wide');
        }

        const cards = buildSizeCards(table);
        if (cards) {
          wrap.insertAdjacentElement('afterend', cards);
        }

        table.dataset.monarchResponsiveTable = 'true';
      });
    };

    const renderFallbackCharts = (root = document) => {
      root.querySelectorAll('[data-monarch-size-guide-fallback]').forEach((fallback) => {
        if (fallback.dataset.ready === 'true') return;
        const template = fallback.querySelector('[data-monarch-size-guide-source]');
        const output = fallback.querySelector('[data-monarch-size-guide-output]');
        if (!template || !output) return;

        const source = document.createElement('div');
        source.append(template.content.cloneNode(true));
        const ordered = Array.from(source.querySelectorAll('h1, h2, h3, h4, table'));
        const tables = ordered.filter((element) => element.tagName === 'TABLE');
        output.replaceChildren();

        tables.forEach((table, index) => {
          const tablePosition = ordered.indexOf(table);
          const heading = ordered.slice(0, tablePosition).reverse().find((element) => element.tagName !== 'TABLE');
          const title = normalizeLabel(heading?.textContent || '') || inferProductLabel(fallback.dataset.productTitle || '') || `Measurements ${index + 1}`;
          const section = document.createElement('section');
          const headingElement = document.createElement('h3');
          const wrap = document.createElement('div');

          headingElement.textContent = title;
          wrap.className = 'monarch-size-guide-drawer__table-wrap';
          wrap.append(cleanTable(table));
          section.append(headingElement, wrap);
          output.append(section);
        });

        if (!tables.length) {
          const empty = document.createElement('p');
          empty.className = 'monarch-size-guide-drawer__empty';
          empty.textContent = fallback.dataset.emptyMessage || '';
          output.append(empty);
        }

        fallback.dataset.ready = 'true';
      });
    };

    const bodyChart = [
      { size: 'XXS', bust: 81, waist: 63, hip: 89 },
      { size: 'XS', bust: 85, waist: 67, hip: 93 },
      { size: 'S', bust: 89, waist: 71, hip: 97 },
      { size: 'M', bust: 93, waist: 75, hip: 101 },
      { size: 'L', bust: 99, waist: 81, hip: 107 },
      { size: 'XL', bust: 105, waist: 87, hip: 113 },
      { size: 'XXL', bust: 111, waist: 93, hip: 119 },
    ];

    const fitEase = {
      close: { bust: 4, waist: 2, hip: 4 },
      regular: { bust: 8, waist: 4, hip: 6 },
      easy: { bust: 12, waist: 6, hip: 10 },
    };

    const sizeRanks = {
      XXS: 0,
      XS: 1,
      S: 2,
      M: 3,
      'M/L': 4,
      L: 5,
      'L/XL': 6,
      XL: 7,
      XXL: 8,
    };

    const fillTemplate = (template, values) => Object.entries(values).reduce(
      (message, item) => message.replaceAll(`[${item[0]}]`, item[1]),
      template || ''
    );

    const readNumber = (assist, key) => {
      const value = assist.querySelector(`[data-monarch-size-assist-input="${key}"]`)?.value;
      if (value === '' || value == null) return null;
      const number = Number(String(value).replace(',', '.'));
      return Number.isFinite(number) ? number : null;
    };

    const getSelectedRadioValue = (assist, selector, fallback = '') => assist.querySelector(`${selector}:checked`)?.value || fallback;

    const getSizeRank = (size) => {
      const cleaned = cleanText(size).toUpperCase();
      if (sizeRanks[cleaned] != null) return sizeRanks[cleaned];
      const parts = cleaned.split(/[^A-Z]+/).filter(Boolean);
      return parts.reduce((rank, part) => Math.max(rank, sizeRanks[part] ?? rank), -1);
    };

    const getMeasurementKeys = (header) => {
      const label = header.toLowerCase();
      const keys = [];
      if (label.includes('bust') || label.includes('chest')) keys.push('bust');
      if (label.includes('waist')) keys.push('waist');
      if (label.includes('hip')) keys.push('hip');
      return keys;
    };

    const parseMeasurement = (value) => {
      const numbers = cleanText(value).replace(/,/g, '.').match(/\d+(?:\.\d+)?/g)?.map(Number) || [];
      if (!numbers.length) return null;
      return {
        min: numbers.length > 1 ? Math.min(...numbers) : null,
        max: Math.max(...numbers),
      };
    };

    const getChartTitle = (wrap) => {
      const previous = wrap.previousElementSibling;
      if (previous && /^H[1-6]$/.test(previous.tagName)) return cleanText(previous.textContent);
      const sectionHeading = wrap.closest('section')?.querySelector('h3');
      return sectionHeading ? cleanText(sectionHeading.textContent) : '';
    };

    const getProductCharts = (assist) => {
      const drawer = assist.closest('.monarch-size-guide-drawer');
      const productPanel = drawer?.querySelector('.monarch-size-guide-drawer__panel--product');
      if (!productPanel) return [];
      if (productPanel.dataset.monarchSizeGuideChartKind === 'body_range') return [];

      return Array.from(productPanel.querySelectorAll('.monarch-size-guide-drawer__table-wrap')).map((wrap) => {
        const table = wrap.querySelector('table');
        const headers = table ? getTableHeaders(table) : [];
        const rows = table ? getTableRows(table).map((values) => {
          const measurements = [];
          headers.forEach((header, index) => {
            const parsed = parseMeasurement(values[index]);
            if (!parsed) return;
            getMeasurementKeys(header).forEach((key) => {
              measurements.push({
                key,
                min: parsed.min,
                max: parsed.max,
              });
            });
          });

          return {
            size: values[0] || '',
            measurements,
          };
        }).filter((row) => row.size && row.measurements.length) : [];

        return {
          title: getChartTitle(wrap),
          rows,
        };
      }).filter((chart) => chart.rows.length);
    };

    const evaluateProductRow = (row, measurements, fit) => {
      const ease = fitEase[fit] || fitEase.regular;
      let checks = 0;
      let deficit = 0;
      let slack = 0;

      row.measurements.forEach((measurement) => {
        const bodyValue = measurements[measurement.key];
        if (!bodyValue) return;
        const target = measurement.min == null ? bodyValue + ease[measurement.key] : bodyValue;
        const difference = measurement.max - target;
        checks += 1;
        if (difference < 0) {
          deficit += Math.abs(difference);
        } else {
          slack += Math.min(difference, 24);
        }
      });

      if (!checks) return null;
      return {
        checks,
        deficit,
        pass: deficit <= 0,
        slack,
      };
    };

    const getProductSuggestions = (assist, measurements, fit) => getProductCharts(assist).map((chart) => {
      const candidates = chart.rows.map((row) => ({
        row,
        fit: evaluateProductRow(row, measurements, fit),
      })).filter((candidate) => candidate.fit);

      if (!candidates.length) return null;

      const passing = candidates.find((candidate) => candidate.fit.pass);
      const chosen = passing || candidates.sort((a, b) => (
        a.fit.deficit - b.fit.deficit
        || b.fit.checks - a.fit.checks
        || getSizeRank(b.row.size) - getSizeRank(a.row.size)
      ))[0];

      return {
        title: chart.title,
        size: chosen.row.size,
        pass: chosen.fit.pass,
      };
    }).filter(Boolean);

    const getBodySuggestion = (measurements, fit) => {
      let index = bodyChart.findIndex((row) => (
        measurements.bust <= row.bust
        && measurements.waist <= row.waist
        && measurements.hip <= row.hip
      ));
      if (index === -1) return null;
      if (fit === 'easy') index = Math.min(index + 1, bodyChart.length - 1);
      return bodyChart[index].size;
    };

    const getOverallProductSize = (suggestions) => suggestions.reduce((best, suggestion) => {
      if (!best) return suggestion.size;
      return getSizeRank(suggestion.size) > getSizeRank(best) ? suggestion.size : best;
    }, '');

    const setAssistFigure = (assist, measurements) => {
      const scaleValue = (value, min, max) => {
        if (!value) return 0.24;
        return Math.max(0.24, Math.min(1, (value - min) / (max - min))).toFixed(2);
      };

      assist.style.setProperty('--assist-bust', scaleValue(measurements.bust, 60, 150));
      assist.style.setProperty('--assist-waist', scaleValue(measurements.waist, 45, 140));
      assist.style.setProperty('--assist-hip', scaleValue(measurements.hip, 70, 160));
      assist.dataset.filled = Object.values(measurements).some(Boolean) ? 'true' : 'false';
    };

    const renderBreakdown = (breakdown, assist, bodySize, suggestions, bodyLabel = assist.dataset.bodyLabel) => {
      if (!breakdown) return;
      breakdown.replaceChildren();

      if (bodySize) {
        const item = document.createElement('span');
        item.textContent = `${bodyLabel || 'Body'}: ${bodySize}`;
        breakdown.append(item);
      }

      suggestions.forEach((suggestion) => {
        const item = document.createElement('span');
        const title = suggestion.title || assist.dataset.productLabel || 'Product';
        item.textContent = `${title}: ${suggestion.size}`;
        breakdown.append(item);
      });

      breakdown.hidden = !breakdown.children.length;
    };

    const initAssist = (root = document) => {
      root.querySelectorAll('[data-monarch-size-assist]').forEach((assist) => {
        if (assist.dataset.ready === 'true') return;
        const result = assist.querySelector('[data-monarch-size-assist-result]');
        const status = assist.querySelector('[data-monarch-size-assist-status]');
        const sizeOutput = assist.querySelector('[data-monarch-size-assist-size]');
        const message = assist.querySelector('[data-monarch-size-assist-message]');
        const breakdown = assist.querySelector('[data-monarch-size-assist-breakdown]');

        const setResult = (state, size, resultMessage, resultStatus = assist.dataset.resultLabel) => {
          if (result) result.dataset.state = state;
          if (status) status.textContent = resultStatus || '';
          if (sizeOutput) sizeOutput.textContent = size || '--';
          if (message) message.textContent = resultMessage || '';
        };

        const update = () => {
          const fit = getSelectedRadioValue(assist, '[data-monarch-size-assist-fit]', 'regular');
          const measurements = {
            bust: readNumber(assist, 'bust'),
            waist: readNumber(assist, 'waist'),
            hip: readNumber(assist, 'hip'),
          };

          setAssistFigure(assist, measurements);

          if (!(measurements.bust && measurements.waist && measurements.hip)) {
            setResult('empty', '', assist.dataset.emptyMessage);
            if (breakdown) breakdown.hidden = true;
            return;
          }

          const bodySize = getBodySuggestion(measurements, fit);
          if (!bodySize) {
            setResult('warning', '', assist.dataset.overChartMessage);
            if (breakdown) breakdown.hidden = true;
            return;
          }

          const productSuggestions = getProductSuggestions(assist, measurements, fit);
          const productSize = getOverallProductSize(productSuggestions);
          const size = productSize || bodySize;
          const fitMessage = fit === 'close'
            ? assist.dataset.closeMessage
            : fit === 'easy'
              ? assist.dataset.easyMessage
              : assist.dataset.regularMessage;
          const messageValues = {
            size,
            body_size: bodySize,
          };
          const productMessage = productSize
            ? fillTemplate(assist.dataset.productMessage, messageValues)
            : assist.dataset.productNote;
          const confidence = productSuggestions.length && productSuggestions.every((suggestion) => suggestion.pass)
            ? assist.dataset.strongMatch
            : assist.dataset.closeMatch;

          setResult('ready', size, productMessage || fillTemplate(fitMessage, { size }), confidence);
          renderBreakdown(breakdown, assist, bodySize, productSuggestions);
        };

        assist.querySelectorAll('input').forEach((input) => input.addEventListener('input', update));
        assist.querySelectorAll('input[type="radio"]').forEach((input) => input.addEventListener('change', update));
        update();
        assist.dataset.ready = 'true';
      });
    };

    const init = (root = document) => {
      renderFallbackCharts(root);
      enhanceResponsiveTables(root);
      initAssist(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
